/**
 * Frontend mirror of the backend working-period rule in
 * `services/coms/src/routes/ICS/workingOperationalPeriod.ts`. The two must agree: the client decides which period to
 * read and write, and the server rejects anything that is not the working one.
 *
 * Normally the current period is closed and planning happens against the next, so working = current + 1. Initial
 * Response is the exception: an incident created but not yet escalated authors against period 0 itself.
 */

type WorkingPeriodInput = {
  currentPeriodNumber: number;
  isEscalated: boolean;
};

/**
 * Whether the incident is in Initial Response, the one state that authors against period 0.
 *
 * Escalation is what ends it, not the period number. An escalated incident sits on period 0 for its whole first
 * Planning P cycle and belongs to Planning P throughout.
 */
export function isInitialResponsePeriod({
  currentPeriodNumber,
  isEscalated,
}: WorkingPeriodInput): boolean {
  return currentPeriodNumber === 0 && !isEscalated;
}

export function resolveWorkingPeriodNumber(input: WorkingPeriodInput): number {
  return isInitialResponsePeriod(input) ? 0 : input.currentPeriodNumber + 1;
}
